export const PASSWORD_MIN_LENGTH = 12
export const PASSWORD_MAX_LENGTH = 30

export const passwordPatterns = {
  lowercase: /[a-z]/,
  uppercase: /[A-Z]/,
  specialCharacter: /[^\p{L}\p{N}\s]/u
}

export const validatePassword = password => {
  if (!password) return ['Value required']

  const errors = []
  if (password.length < PASSWORD_MIN_LENGTH) {
    errors.push(`Password must be at least ${PASSWORD_MIN_LENGTH} characters`)
  }
  if (password.length > PASSWORD_MAX_LENGTH) {
    errors.push(`Password must be no more than ${PASSWORD_MAX_LENGTH} characters`)
  }
  if (!passwordPatterns.lowercase.test(password)) {
    errors.push('Password must contain at least one lowercase letter')
  }
  if (!passwordPatterns.uppercase.test(password)) {
    errors.push('Password must contain at least one uppercase letter')
  }
  if (!passwordPatterns.specialCharacter.test(password)) {
    errors.push('Password must contain at least one special character')
  }

  return errors
}
